export const getAppTenant = async (platform, lang, welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get(`/organization/entity/${platform}`, {
      params: { lang: lang },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};
